function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import logJsUnexpected from "@zr/utilities/telemetry/logJsUnexpected";
/**
 * Initialize Google Tag Manager. GTM should not be initialized more than once on a page.
 * If no container ID was specified, an error will log and GTM will not initialize.
 *
 * @param cID - ID of the GTM container to report events to.
 */ export var initGoogleTagManager = function(cID) {
    if (!cID) {
        logJsUnexpected("missing_gtm_container_id");
        return;
    }
    // Lots of directive-style comments here to prevent prettier from making
    // the snippet pretty + asking TypeScript to ignore this farglebargle.
    // prettier-ignore
    // eslint-disable-next-line
    // @ts-ignore
    // eslint-disable-next-line
    (function(w, d, s, l, i) {
        var n = d.querySelector("[nonce]");
        var nonceVal = n.nonce || n.getAttribute("nonce");
        w[l] = w[l] || [];
        w[l].push({
            "gtm.start": new Date().getTime(),
            "nonce": nonceVal,
            event: "gtm.js"
        });
        var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        n && j.setAttribute("nonce", nonceVal);
        f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", cID);
};
/**
 * Generic method to fire a GTM event.
 *
 * @param event - Name of the event to be fired.
 * @param properties - Key value pairs of properties to be added to the event.
 */ export var fireGtmEvent = function(event) {
    var properties = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (window.dataLayer) {
        window.dataLayer.push(_object_spread({
            event: event
        }, properties));
    }
};
/**
 * Fires off a GTM `page` event.
 *
 * @param pageEvent - Values required for the GTM 'page' event.
 */ export var firePageEvent = function(pageEvent) {
    fireGtmEvent("page", pageEvent);
};
/**
 * Fires off a GTM `contact` event.
 *
 * @param contactEvent - Values required for the GTM 'contact' event.
 */ export var fireContactEvent = function(contactEvent) {
    fireGtmEvent("contact", contactEvent);
};
/**
 * Fires off a GTM `job` event.
 *
 * @param jobEvent - Values required for the GTM 'job' event.
 */ export var fireJobEvent = function(jobEvent) {
    fireGtmEvent("job", jobEvent);
};
export var fireExperianPageViewEvent = function(campaignEventAlreadyFired) {
    if (campaignEventAlreadyFired) {
        return;
    }
    fireGtmEvent("605-experian-js-pageview");
};
